import { render, staticRenderFns } from "./ReservationsAdd.vue?vue&type=template&id=143cc9f3"
import script from "./ReservationsAdd.vue?vue&type=script&lang=js"
export * from "./ReservationsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports